import { IMaterialProperties } from 'app/shared/model/material-properties.model';

export interface IMaterialSource {
  id?: number;
  name?: string;
  materialProperties?: IMaterialProperties[] | null;
}

export const defaultValue: Readonly<IMaterialSource> = {};
